import React, { useState } from 'react';
import { index } from './algolia';
import MovieCard from './MovieCard';
import './Search.css';

const Search = () => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [resultCount, setResultCount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searched, setSearched] = useState(false);

  const handleSearch = async () => {
    if (!query.trim()) return;
    setLoading(true);
    setError(null);
    try {
      const { hits, nbHits } = await index.search(query, { hitsPerPage: 30 });
      setResults(hits);
      setResultCount(nbHits);
      setSearched(true);
    } catch (err) {
      setError('Search failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className="search-page">
      <div className="search-page__bar">
        <input
          type="text"
          className="search-page__input"
          placeholder="Search movies..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          autoFocus
        />
        <button
          className="search-page__submit"
          onClick={handleSearch}
          disabled={loading}
        >
          {loading ? '...' : 'Go'}
        </button>
      </div>

      {error && <p className="search-page__error">{error}</p>}

      {resultCount !== null && (
        <p className="search-page__count">
          {resultCount === 0 ? 'No movies found.' : `${resultCount} result${resultCount !== 1 ? 's' : ''}`}
        </p>
      )}

      {!searched && !loading && (
        <p className="search-page__empty">Search by title, genre, or director.</p>
      )}

      <div className="search-page__results">
        {results.map((hit) => (
          <MovieCard key={hit.objectID} movie={hit} />
        ))}
      </div>
    </div>
  );
};

export default Search;
